<template>
	<NuxtLink :to="item.url_without_domain" :class="['pp', mode == 'big' && 'pp-big', mode == 'small' && 'pp-special-small']">
		<figure class="pp-image">
			<span><BaseUiImage loading="lazy" :data="imageOptions.image" :default="imageOptions.noImage" :title="item.main_image_title"  :alt="item.main_image_description" /></span>
		</figure>
		<div class="pp-cnt">
			<h2 v-if="item.title" class="pp-title">{{item.title}}</h2>
			<div v-if="item.short_description && mode != 'events'" class="pp-short-desc">
				<template v-if="mode == 'small'">{{stripHtml(limitWords(item.short_description, 15, '...'))}}</template>
				<template v-else-if="mode == 'big' && mobileBreakpoint">{{stripHtml(limitWords(item.short_description, 22, '...'))}}</template>
				<template v-else>{{stripHtml(item.short_description)}}</template>
			</div>
			<div class="pp-short-desc" v-if="mode == 'events'">
				<BaseUtilsFormatDate :date="item.date" format="DD.MM.YYYY." v-if="item.date" />
				<template v-if="item.date_end"> do <BaseUtilsFormatDate :date="item.date_end" format="DD.MM.YYYY." /></template>
			</div>
		</div>
	</NuxtLink>
</template>

<script setup>
	const props = defineProps(['item', 'mode']);
	const {stripHtml, limitWords} = useText();
	const {mobileBreakpoint} = inject('rwd');

	const imageOptions = computed(() => {
		if(props.mode == 'big') {
			return {image: props.item?.main_image_thumbs?.['width800-height500-crop1'], noImage: '/images/no-image-800.jpg'};
		}
		if(props.mode == 'small') {
			return {image: props.item?.main_image_thumbs?.['width245-height153-crop1'], noImage: '/images/no-image-245.jpg'};
		}
		return {image: props.item?.main_image_thumbs?.['width445-height280-crop1'], noImage: '/images/no-image-445.jpg'};
	})
</script>

<style lang="less" scoped>
	.pp{
		display: flex; font-size: 18px; line-height: 1.5; color: var(--textColor); text-decoration: none; font-weight: 300; position: relative; flex-wrap: wrap; flex-flow: column; width: calc(~"100%/3 - 7px"); margin-right: 10px; transition: var(--transition); margin-bottom: 90px; padding: 10px;
		@media(min-width: @h){
			&:hover{box-shadow: 0 30px 40px 0 rgba(85,41,122,0.2); background: white; color: var(--textColor);}
		}
	}
	.pp-image{
		flex-shrink: 0;
		:deep(img){width: 100%; height: auto; display: block; max-width: 100%; max-height: 100%;}
	}
	.pp-title{padding-top: 0; padding-bottom: 7px; font-size: 22px; line-height: 1.25; font-weight: normal; color: var(--primaryColor);}
	.pp-short-desc{ 
		padding-bottom: 0;
		p{font-size: 18px; line-height: 26px; color: var(--textColor); padding-bottom: 7px; font-weight: 300;}
	}
	.pp-cnt{padding: 20px 30px 15px;}

	.pp-big{
		width: 100%; padding: 0; margin-bottom: 0; font-weight: normal;
		@media(min-width: @h){
			&:hover{box-shadow: none; background: none;}
		}
		.pp-cnt{position: relative; background: white; padding: 45px 55px; box-shadow: 0 30px 40px 0 rgba(85,41,122,0.28); margin: -85px 42px 0;}
		.pp-title{font-size: 36px; font-weight: 300; line-height: 1.15;}
		.pp-short-desc{line-height: 1.4;
			p{line-height: 1.4;}
		}
	}

	.pp-special-small{
		width: 100%; margin: 0; font-size: 16px; flex-flow: row; padding: 0; margin-bottom: 20px;
		&:last-child{margin-bottom: 0;}
		.pp-cnt{background: none; padding: 10px 10px 10px 25px;}
		.pp-short-desc{font-weight: 400; line-height: 1.4;
			p{font-weight: 400; line-height: 1.4;}
		}
		.pp-title{font-size: 20px; padding-bottom: 3px;}
		.pp-image{
			width: 245px; flex-grow: 0; flex-shrink: 0;
			&.loaded{background: none;}
		}
	}

	@media (max-width: @l){
		.pp{width: calc(~"100%/3 - 20px"); margin-right: 20px; margin-bottom: 80px;}
		.pp-big{width: 700px;}  
		.pp-special-small{width: 100%; margin: 0; display: flex; flex-flow: row; align-items: center; padding: 0; margin-bottom: 20px;
			&:last-child{margin-bottom: 0;}
		}      
	}

	@media (max-width: @t){
		.pp{font-size: 16px; margin-right: 20px; margin-bottom: 45px; padding: 0;}
		.pp-cnt{padding: 15px 12px;}
		.pp-title{font-size: 20px; line-height: 1.3; padding-bottom: 7px;}
		.pp-short-desc{font-size: 16px; line-height: 22px;
			p{font-size: 16px; line-height: 22px;}
		}  
		.pp-big{width: 500px; margin-right: 0; margin-bottom: 0;
			.pp-cnt{padding: 25px; margin: -50px 30px 0;}
			.pp-title{font-size: 24px; padding-bottom: 6px;}
			.pp-short-desc{font-size: 16px; line-height: 22px; padding-bottom: 0;
				p{font-size: 16px; line-height: 22px; padding-bottom: 0;}
			}
		} 
		.pp-special-small{
			margin: 0 0 15px;
			.pp-image{width: 152px;}
			.pp-cnt{padding: 0 0 0 15px;}
			.pp-title{font-size: 16px; padding-bottom: 3px;}
			.pp-short-desc{font-size: 14px;
				p{font-size: 14px;}
			}
		}
	}

	@media (max-width: @tp){
		.pp{margin-right: 15px; margin-bottom: 35px; width: calc(~"100%/3 - 10px");}
		.pp-cnt{padding: 12px 11px;}
		.pp-title{font-size: 18px;  padding-bottom: 7px;}
	
		.pp-big{width: 390px; margin-right: 0; margin-bottom: 0;
			.pp-title{font-size: 20px; padding-bottom: 5px; font-weight: bold;}
			.pp-cnt{padding: 23px 20px; margin: -45px 15px 0;}
		}

		.pp-special-small{margin: 0 0 13px; width: 100%;
			.pp-image{width: 120px;}
			.pp-cnt{padding: 8px 0 8px 12px;}
			.pp-short-desc{display: none;}
		}
	}

	@media (max-width: @m){
		.pp{width: 100%; margin-right: 0; margin-bottom: 25px;}
		.pp-cnt{padding: 12px 0;}
		.pp-short-desc{
			font-size: 16px; line-height: 21px;
			p{font-size: 16px; line-height: 21px;}
		}
		.pp-big{
			margin-bottom: 0;
			.pp-cnt{padding: 10px 15px 0; margin: 0; box-shadow: none; background: none;}
			.pp-short-desc{font-size: 16px; line-height: 21px;}
			@media(min-width: @h){
				&:hover{color: var(--textColor);}
			}
		}
		.pp-title{font-weight: bold; line-height: 22px;}
		.pp-special-small{margin: 0 0 10px;
			.pp-image{width: 160px;}
			.pp-title{font-size: 18px; font-weight: normal; line-height: 21px; color: var(--textColor);}
			.pp-cnt{padding: 0 0 0 15px;}
		}
	}
</style>